/**
 * useUnblock Hook
 * 
 * Custom hook for managing unblock logic.
 */

import * as React from "react";
import { blockService, type Block } from "@/services/blockService";
import { toast } from "sonner";

interface UseUnblockProps {
  onSuccess?: () => void;
}

export function useUnblock({ onSuccess }: UseUnblockProps = {}) {
  const [unblocking, setUnblocking] = React.useState(false);

  const handleUnblock = React.useCallback(async (block: Block) => {
    setUnblocking(true);
    try {
      // Determine which identifier to use - prefer callsign if available, otherwise use id_client
      let identifier: string;
      let by: "callsign" | "id_client";
      
      if (block.callsign && block.callsign.trim() !== "") {
        identifier = block.callsign;
        by = "callsign";
      } else if (block.id_client && block.id_client.trim() !== "") {
        identifier = block.id_client;
        by = "id_client";
      } else {
        toast.error("Gagal unblock user", {
          description: "Callsign atau ID Client tidak ditemukan",
        });
        setUnblocking(false);
        return;
      }

      const result = await blockService.unblockUser(identifier, by);

      if (result.success) {
        toast.success("User berhasil di-unblock", {
          description: `User ${identifier} telah di-unblock`,
        });
        onSuccess?.();
      } else {
        toast.error("Gagal unblock user", {
          description: result.message,
        });
      }
    } catch (err) {
      console.error("Error unblocking user:", err);
      toast.error("Gagal unblock user", {
        description: err instanceof Error ? err.message : "Terjadi kesalahan saat unblock user",
      });
    } finally {
      setUnblocking(false);
    }
  }, [onSuccess]);

  return {
    unblocking,
    handleUnblock,
  };
}

